import React, { Component, Fragment } from "react";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import { dataFormatters } from "../../../../utils/dataFormatters";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";
import { JointBarFractureReportSchema } from "./JointBarFractureReportSchema";
import { TickBoxAndLabelSectionRenderer } from "../../../../libraries/ReportGenerator/TickBoxAndLabelSectionRenderer";

const SubTitle = ({ title }) => {
  return <span style={{ fontSize: "14px", fontWeight: "normal", fontStyle: "italic" }}>{title}</span>;
};

const reportStyles = {
  sectionStyles: {
    width: "100%",
    minWidth: "fit-content",
    maxWidth: "100%",
    border: "1px solid black",
    padding: "10px",
  },
};

const ReportView = (props) => {
  let reportData = props.reportData ? props.reportData : {};
  let { milepost, location, user, date, formSummary, subdivision } = reportData;
  if (!formSummary) formSummary = {};
  let isMaintenance = props.isMaintenance;
  let data = {
    lineName: subdivision,
    location: location,
    user: user ? user.name : "",
    milepost: milepost,
    reportDate: dataFormatters.dateFormatter(date),
    ...formSummary,
  };

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title="APPENDIX 5 - CWR Joint Bar Fracture Report" {...props} centerTitle={true} isMaintenance={isMaintenance} />
      <ReportInfoSection
        fontSizeOverride={"20px"}
        rows={[
          {
            col1: {
              title: "SUBDIVISION",
              value: data.lineName,
            },
            col2: {
              title: "MILEPOST",
              value: data.miles,
            },
          },
          {
            col1: {
              title: "DATE FOUND",
              value: data.dateFound,
            },
            col2: {
              title: "ANNUAL MGT",
              value: data.annmgt,
            },
          },

          {
            col1: {
              title: "TRACK #",
              value: data.trackno,
            },
            col2: {
              title: "TRACK CLASS",
              value: data.tclass,
            },
          },
        ]}
      />

      <span className="spacer"></span>
      <div style={reportStyles.sectionStyles}>
        <TickBoxAndLabelSectionRenderer title={"TYPE OF INSPECTION"} data={data} rows={JointBarFractureReportSchema.typeOfInspection} />
      </div>

      <span className="spacer"></span>
      <div style={reportStyles.sectionStyles}>
        <TickBoxAndLabelSectionRenderer title={""} data={data} rows={JointBarFractureReportSchema.generalInfoSection} />
      </div>

      <span className="spacer"></span>

      <div style={reportStyles.sectionStyles}>
        <TickBoxAndLabelSectionRenderer
          title={"BAR TYPE"}
          titleStyle={{ fontSize: "22px" }}
          titlePostComp={<SubTitle title={"(check all that apply)"} />}
          data={data}
          rows={JointBarFractureReportSchema.barType}
        />
      </div>
      <span className="spacer"></span>

      <div style={{ display: "flex", alignItems: "center", flexDirection: "row" }}>
        <div style={reportStyles.sectionStyles}>
          <TickBoxAndLabelSectionRenderer
            title={"FIELD SIDE BAR"}
            titleStyle={{ fontSize: "22px" }}
            sectionStyle={{ textAlign: "center", display: "block" }}
          />
          <TickBoxAndLabelSectionRenderer title={"BROKEN THROUGH"} data={data} rows={JointBarFractureReportSchema.fieldBroken} />
          <TickBoxAndLabelSectionRenderer title={"CRACKED"} data={data} rows={JointBarFractureReportSchema.fieldCracked} />
        </div>

        <div style={reportStyles.sectionStyles}>
          <TickBoxAndLabelSectionRenderer
            title={"GAGE SIDE BAR"}
            titleStyle={{ fontSize: "22px" }}
            sectionStyle={{ textAlign: "center", display: "block" }}
          />
          <TickBoxAndLabelSectionRenderer title={"BROKEN THROUGH"} data={data} rows={JointBarFractureReportSchema.gageBroken} />
          <TickBoxAndLabelSectionRenderer title={"CRACKED"} data={data} rows={JointBarFractureReportSchema.gageCracked} />
        </div>
      </div>
      <span className="spacer"></span>
      <div style={reportStyles.sectionStyles}>
        <TickBoxAndLabelSectionRenderer title={""} data={data} rows={JointBarFractureReportSchema.gapBetween} />
        <TickBoxAndLabelSectionRenderer title={"RAIL END BATTER OR RAMP"} data={data} rows={JointBarFractureReportSchema.railEnd} />
        <TickBoxAndLabelSectionRenderer title={""} data={data} rows={JointBarFractureReportSchema.treadMismatch} />
        <TickBoxAndLabelSectionRenderer title={""} data={data} rows={JointBarFractureReportSchema.jointVertical} />
      </div>
      <span className="spacer"></span>
      <div style={reportStyles.sectionStyles}>
        <TickBoxAndLabelSectionRenderer title={""} data={data} rows={JointBarFractureReportSchema.jointInCurve} />
        <TickBoxAndLabelSectionRenderer title={""} data={data} rows={JointBarFractureReportSchema.gageRamp} />
        <TickBoxAndLabelSectionRenderer title={""} data={data} rows={JointBarFractureReportSchema.gageMismatch} />
        <TickBoxAndLabelSectionRenderer title={""} data={data} rows={JointBarFractureReportSchema.jointLateral} />
      </div>
      <span className="spacer"></span>
      <div style={{ ...reportStyles.sectionStyles, minHeight: "200px" }}>
        <span style={{ padding: "8px", display: "inline-block" }}>
          {" "}
          <TickBoxAndLabelSectionRenderer title={"OTHER COMMENTS:"} titleStyle={{ padding: "0px" }} data={data} rows={[]} />
          <span>{data.othcomment}</span>
        </span>
      </div>
    </div>
  );
};

const SCFE_JointBarFractureReport = (props) => {
  const { inspec } = props;
  const isMaintenance = props.isMaintenance ? props.isMaintenance : ReportGeneratorUtils.checkIfMaintenance(inspec);
  const title = inspec.title ? inspec.title : null;
  let formSummaries = isMaintenance
    ? ReportGeneratorUtils.getMaintenanceAppForms(inspec, ["scfe_m_CWRJointBarFracture"])
    : ReportGeneratorUtils.getInspectionAppForms(inspec, ["scfe_i_CWRJointBarFracture"]);

  return formSummaries.map((summary, _i) => (
    <ReportView
      {...props}
      reportData={{
        formSummary: summary,
        title: title,
        location: isMaintenance ? ReportGeneratorUtils.getMaintenanceLocation(inspec) : ReportGeneratorUtils.getInspectionLocation(inspec),
        subdivision: isMaintenance
          ? ReportGeneratorUtils.getMaintenanceSubdivision(inspec)
          : ReportGeneratorUtils.getInspectionSubdivision(inspec),
        date: ReportGeneratorUtils.getInspectionDate(inspec),
        user: ReportGeneratorUtils.getInspectionUser(inspec),
        isMaintenance: isMaintenance,
      }}
    />
  ));
};

export default SCFE_JointBarFractureReport;



// WEBPACK FOOTER //
// ./src/components/Reports/SCFE/JointBarFractureReport/index.jsx